/* eslint-disable array-callback-return */
/* eslint-disable react/no-unused-state */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-else-return */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable no-shadow */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-indent */
/* eslint-disable object-curly-newline */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Row, FormGroup, Label, Button, Nav, NavItem, NavLink, TabContent, TabPane, Col, } from 'reactstrap';
import classnames from 'classnames';
import 'react-datepicker/dist/react-datepicker.css';
import { capitalize, forEach, map, some } from 'lodash';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { connect } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import Icon from '@mdi/react';
import { mdiDownloadOutline, mdiPhone } from '@mdi/js';
import { setRUTFormat, isUserAllowed, isOptionAllowed } from '../../../shared/utils';
import BasicNotification from '../../../shared/components/Notifications/BasicNotification';
import DModal from '../../../shared/components/Modal/Modal';
import EModal from '../../../shared/components/Modal/ModalE';
import EvaluateModal from '../../../shared/components/Modal/ModalEvaluation';
import ModalContactoEdit from '../../Contactos/components/ModalContactoEdit';
import CloseQuotationsModal from '../../../shared/components/Modal/CloseQuotationsModal';
import MailsContents from './MailsContents';
import GestionComponent from './GestionComponent';
import {
  getCasesIdMe,
  deleteCase,
  getAllTypesCases,
  getAllSubTypesCases,
  updateCase,
  createCase,
  createMyCase,
} from '../../../redux/actions/casesActions';
import {
  getContactByRut,
  getContractByRut,
} from '../../../redux/actions/contactosActions';
import {
  createQuotations,
  createQuotationsMe,
  updateQuotations,
  updateQuotationMany,
  updateQuotationsMe,
  getQuotationById,
  getQuotationByIdMe,
  getSignedDocumentQuotation,
  deleteQuotations,
} from '../../../redux/actions/quotationsActions';
import {
  getRegions,
  getSettings,
  getCommuns,
  getCivilStatus,
  getOrigins,
} from '../../../redux/actions/resourcesActions';
import { getAllManagements } from '../../../redux/actions/managementActions';
import { getUsers, makeCall, getMe } from '../../../redux/actions/userActions';
import { changeTitleAction } from '../../../redux/actions/topbarActions';
import { ADMIN_QUOTATION_ROLE_FILTER, BATCH_API, FIRST_SECOND_CONTACT, FIRST_SECOND_CONTACT_FILTER, ROLES } from '../../../helper/constants';
import MakeCall from '../../../shared/components/make-call';
import ManagementHistoryComponent from './ManagementHistoryComponent';
import NewActivityComponent from './NewActivityComponent';
import PersonalData from './details-components/PersonalData';
import ListingData from './details-components/ListingData';
import LaborData from './details-components/LaborData';
import { validateEmail } from '../../../helper/functions';
import { Toaster, toast } from 'react-hot-toast';
import LoadingScreen from '../../MiPanel/components/LoadingScreen';
import PortabilityData from './details-components/PortabilityData';

class QuotationDetalle extends Component {
  constructor() {
    super();
    this.state = {
      activeTab: '1',
      isOpenModalD: false,
      isOpenModalContactEdit: false,
      isOpenModalE: false,
      isOpenModalCloseQuotations: false,
      isOpenEvaluateModal: false,
      isOpenModalAssignActivity: false,
      isOpenModalMessageMail: false,
      idDetail: null,
      isAdmin: false,
      new: false,
      _id: '',
      client: '',
      executive: null,
      haveProperty: false,
      haveVehicle: false,
      companyName: '',
      companyRUT: '',
      typeContract: null,
      concessionaire: '',
      dateEntry: null,
      status: '',
      workPhone: '',
      workSituation: null,
      officePhone: '',
      origin: { label: '', value: '' },
      trinidadCode: null,
      clientEvaluation: null,
      carPatent: null,
      users: [],
      updateLocal: false,
      editField: true,
      showButton: false,
      code: 0,
      activities: [],
      activity: {
        description: null,
        executive: null,
      },
      typeVehicle: null,
      priceVehicle: '',
      initialPayment: '',
      numberOfFees: 0,
      feeToPay: '',
      names: '',
      paternalSurname: '',
      maternalSurname: '',
      rut: '',
      messages: undefined,
      NewMessage: {
        editor: null,
        attachments: [],
      },
      birthdate: '',
      phone: '',
      civilStatus: '',
      address: {
        street: null,
        region: null,
        commune: null,
      },
      email: '',
      sourceMail: '',
      emailArrayToMailsContents: [],
      namesCrm: '',
      paternalCrm: '',
      rutCrm: '',
      //nuevos campos
      nacionality: '',
      brand: '',
      brandId: '',
      model: '',
      year: '',
      dateState: '',
      expirationDate: '',
      evaluationState: '',
      evaluationStatus: {},
      trinidadStatus: '',
      carState: '',
      term: '',
      cae: '',
      channelName: '',
      dealerName: '',
      branchName: '',
      sellerName: '',
      rentType: '',
      antiquity: '',
      rent: '',
      fromSimulation: false,
      disableToDo: false,
      plan: null,
      fixedIncome: false,
      variableIncome: false,
      averageIncome: '',
      clientActivity: null,
      sentInformationRequest: null,
      sentClientResponse: null,
      toDo: {
        action: 'updateToDo',
        payload: {
          customerContacted: {
            status: false,
            date: null,
          },
          completedForm: {
            status: false,
            date: null,
          },
          FAndIDerivative: {
            status: false,
            date: null,
          },
          clientVisit: {
            status: false,
            date: null,
          },
        },
      },
      callPhone: null,
      isMakeCallOpen: false,
      userData: '',
      historyTab: '2',
      nameEF: '',
      isPort: false,
      financialProducts: '',
      financialProductsToImport: '',
      originalFeeValue: '',
      totalPaidFees: '',
      licensePlate: '',
      originalCreditAmount: '',
      originalPeriod: '',
      signedDoc: undefined,
      description: ''
    };
  }

  componentDidMount() {
    this.props.getOrigins();
    this.handleGetComponentData();
    isOptionAllowed([...FIRST_SECOND_CONTACT, 'admin']) && this.setState({ historyTab: '1' });
  }

  handleGetComponentData = () => {
    const isAdmin = isUserAllowed('admin') || isUserAllowed('manager') || isUserAllowed('first-contact-executive');
    this.setState({ isAdmin });
    const { id, rut } = this.props.match.params;

    this.props.getSettings();
    this.props.getMe((res) => { this.setState({ userData: `${res.firstName} ${res.lastName}` }) });

    this.props.getRegions({ all: true }, (body) => {
      this.setState({ regions: body });
    });
    this.props.setTitle('Detalle cotización');

    this.props.getCivilStatus();

    this.props.getSignedDocumentQuotation(id, (res) => {
      if (res) {
        this.setState({ signedDoc: res });
      }
    });

    if (id) {
      if (isAdmin || isUserAllowed(ROLES.purchaseAdvisorSc)) {
        this.props.getQuotationById(id, (quotationInfo) => {
          if (isAdmin) {
            this.props.getUsers({ all: true, roles: `${ADMIN_QUOTATION_ROLE_FILTER}, ${FIRST_SECOND_CONTACT_FILTER}` }, (body) => {
              this.setState({ users: map(body, user => ({ value: user._id, label: `${user.firstName} ${user.lastName}`, sharpExist: user.sharpExist || false })) });
            });
          }
          this.assignValueOnState(quotationInfo);
        });
      } else {
        this.props.getQuotationByIdMe(id, (quotationInfo) => {
          if (isAdmin) {
            this.props.getUsers({ all: true, roles: `${ADMIN_QUOTATION_ROLE_FILTER}, ${FIRST_SECOND_CONTACT_FILTER}` }, (body) => {
              this.setState({ users: map(body, user => ({ value: user._id, label: `${user.firstName} ${user.lastName}` })) });
            });
          }
          this.assignValueOnState(quotationInfo);
        });
      }
    }

    if (rut) {
      if (isAdmin) {
        this.props.getUsers({ all: true, roles: `${ADMIN_QUOTATION_ROLE_FILTER}, ${FIRST_SECOND_CONTACT_FILTER}` }, (body) => {
          this.setState({ users: map(body, user => ({ value: user._id, label: `${user.firstName} ${user.lastName}` })) });
        });
      }

      this.props.getContactByRut(rut, (body) => {

        this.setState({
          new: false,
          client: body._id,
          createdAt: new Date(),
          namesCrm: (body.names === '') ? body.companyName : body.names,
          paternalCrm: body.paternalSurname || '',
          rutCrm: body.rut ? body.rut : '',
          // phoneClienteCrm: body.phones ? `${body.phones[0].code} ${body.phones[0].number}` : '',
          emailClienteCrm: body.emails[0].email,
          // rentClienteCrm: body.rent ? body.rent : '',
          editField: false,
          // info a precargar
          rut: body.rut ? body.rut : '',
          names: body.names ? body.names : '',
          paternalSurname: body.paternalSurname ? body.paternalSurname : '',
          maternalSurname: body.maternalSurname ? body.maternalSurname : '',
          birthdate: body.birthdate ? moment(body.birthdate).toDate() : '',
          email: body.emails[0].email,
          emailArrayToMailsContents: Array.isArray(body.emails) ? body.emails.map(email => ({ value: email.email, label: email.email })) : [],
          civilStatus: body.civilStatus ? body.civilStatus : '',
          phone: body.phones ? body.phones[0].number : '',
          address: body.addresses ? body.addresses[0] : '',
        });
      });

      this.props.getContractByRut(rut);
    }
  }

  componentDidUpdate(prevProps) {
    const { getContactByRut, getContractByRut, location } = this.props;
    const { rutCrm, updateLocal } = this.state;
    if (location !== prevProps.location) {
      this.handleGetComponentData();
    }
    if (rutCrm && !updateLocal) {
      getContactByRut(rutCrm);
      getContractByRut(rutCrm);
      this.setState({ updateLocal: true });
    }
  }

  assignValueOnState = (value) => {
    const { id } = this.props.match.params;
    const { payload } = this.state.toDo;
    const properties = ['customerContacted', 'completedForm', 'FAndIDerivative', 'clientVisit'];

    properties.forEach(property => {
      payload[property] = (value[property]?.date) ? value[property] : { status: false, date: null };
    });

    this.setState({
      idDetail: id,
      _id: id,
      names: (value.names === '') ? value.companyName : value.names,
      //nuevos campos
      cae: value.CAE,
      brand: value.brand,
      channelName: value.channelName,
      year: value.year,
      dealerName: value.dealerName,
      sellerName: value.sellerName,
      model: value.vehicleModel,
      expirationDate: moment(value.firstExpirationDate).toDate(),
      carState: value.vehicleStatus,
      term: value.term,
      branchName: value.storeName,
      nacionality: value.client.nationality ? value.client.nationality.label : '',
      antiquity: value.antiquity,
      dateState: value.dateState,
      evaluationState: value.evaluationState,
      evaluationStatus: value.evaluationStatus,
      trinidadStatus: value.trinidadStatus,
      clientEvaluation: value.client.trinidadCode,
      //fin nuevos campos
      paternalSurname: value.paternalSurname,
      maternalSurname: value.maternalSurname,
      rut: value.rut || '',
      messages: value.messages ? value.messages : undefined,
      email: value.email ? value.email : '',
      address: value.address ? value.address : '',
      birthdate: value.client.birthdate ? moment(value.client.birthdate).toDate() : '',
      civilStatus: value.civilStatus ? value.civilStatus : '',
      fixedIncome: this.translatePropierty(value.fixedIncome),
      variableIncome: this.translatePropierty(value.variableIncome),
      averageIncome: value.averageIncome ? value.averageIncome : '',
      namesCrm: value.client.names ? value.client.names : '',
      fromSimulation: value.fromSimulation ? value.fromSimulation : false,
      plan: value.plan ? value.plan : null,
      paternalCrm: value.client.paternalSurname ? value.client.paternalSurname : '',
      rutCrm: value.client.rut ? value.client.rut : '',
      emailClienteCrm: value.client.emails ? value.client.emails[0].email : '',
      emailArrayToMailsContents: Array.isArray(value?.client?.emails) ? value.client.emails.map(email => ({ value: email.email, label: email.email })) : [],
      clientActivity: value.clientActivity ? value.clientActivity : '',
      rent: (value.rent) ? value.rent : '',
      workSituation: value.workSituation ? this.translatePropierty(value.workSituation) : null,
      status: (value.status) ? value.status : '',
      phone: value.client.phones[0].number,
      executive: value.executive ? { value: value.executive._id, label: `${value.executive.firstName} ${value.executive.lastName}` } : null,
      haveProperty: this.translatePropierty(value.haveProperty),
      haveVehicle: this.translatePropierty(value.haveVehicle),
      carPatent: value.carPatent ? value.carPatent : '',
      companyName: value.companyName || '',
      companyRUT: (value.companyRUT) ? setRUTFormat(value.companyRUT) : '',
      typeContract: (value.typeContract) ? this.translateContract(value.typeContract) : '',
      concessionaire: value.concessionaire,
      code: value.code,
      trinidadCode: value.trinidadCode || null,
      typeVehicle: value.typeVehicle ? value.typeVehicle : '',
      priceVehicle: (value.priceVehicle) ? value.priceVehicle : '',
      initialPayment: (value.initialPayment) ? value.initialPayment : '',
      numberOfFees: (value.numberOfFees) ? value.numberOfFees : '',
      feeToPay: (value.feeToPay) ? value.feeToPay : '',
      dateEntry: value.dateEntry ? moment(value.dateEntry).toDate() : '',
      workPhone: value.workPhone,
      officePhone: value.officePhone,
      activities: value.activities,
      origin: { value: value.origin, label: value.origin },
      createdAt: value.createdAt,
      client: value.client._id,
      evaluation: value.evaluation,
      sentInformationRequest: value.sentInformationRequest ? moment(value.sentInformationRequest).format('DD/MM/YYYY, h:mm:ss') : null,
      sentClientResponse: value.sentClientResponse ? moment(value.sentClientResponse).format('DD/MM/YYYY, h:mm:ss') : null,
      payload,
      nameEF: value?.nameEF || '',
      isPort: value?.isPort || false,
      financialProducts: value?.financialProducts || '',
      financialProductsToImport: value?.financialProductsToImport || '',
      originalFeeValue: value?.originalFeeValue || '',
      totalPaidFees: value?.totalPaidFees || '',
      licensePlate: value?.licensePlate || '',
      originalCreditAmount: value?.originalCreditAmount || '',
      originalPeriod: value?.originalPeriod || '',
      description: value?.description || '',
    });
  }

  handleSavePDF = async () => {
    const { id } = this.props.match.params;
    if (this.state.signedDoc) {
      this.downloadPDF(this.state.signedDoc, 'autofin_portabilidad.pdf');
    } else {
      await this.props.getSignedDocumentQuotation(id, (res) => {
        this.downloadPDF(res, 'autofin_portabilidad.pdf');
      });
    }
  }

  downloadPDF = (base64file, name) => {
    const byteArray = new Uint8Array(atob(base64file).split('').map(char => char.charCodeAt(0)));
    const pdfBlob = new Blob([byteArray], { type: 'application/pdf' });
    saveAs(pdfBlob, name);
  }

  cancelEdit = () => {
    const { id } = this.props.match.params;
    if (this.state.isAdmin || isUserAllowed(ROLES.purchaseAdvisorSc)) {
      this.props.getQuotationById(id, (quotationInfo) => {
        this.props.getUsers({ all: true, roles: `${ADMIN_QUOTATION_ROLE_FILTER}, ${FIRST_SECOND_CONTACT_FILTER}` }, (body) => {
          this.setState({ users: map(body, user => ({ value: user._id, label: `${user.firstName} ${user.lastName}` })) });
        });
        this.assignValueOnState(quotationInfo);
      });
    } else {
      this.props.getQuotationByIdMe(id, (quotationInfo) => {
        this.assignValueOnState(quotationInfo);
      });
    }
    this.setState({ editField: true, showButton: false });
  }

  translatePropierty = (value) => {
    if (value) {
      const translations = {
        'true': { value: true, label: 'Si' },
        'false': { value: false, label: 'No' },
        auto: { value: 'auto', label: 'Auto' },
        dependent: { value: 'dependent', label: 'Dependente' },
        independent: { value: 'independent', label: 'Independente' },
        moto: { value: 'moto', label: 'Moto' },
        camion: { value: 'camion', label: 'Camión' },
        bus: { value: 'bus', label: 'Bus - Minibus' },
      };

      if (typeof value === "boolean") {
        return translations[value.toString()] || null;
      } else {
        return translations[value] || null;
      }
    } else {
      return null;
    }
  };

  findIcon = (origin) => {
    if (origin) {
      if (origin.value === 'phone') {
        return 'phone-handset';
      }
      if (origin.value === 'web') {
        return 'laptop';
      }
      if ((origin.value === 'referred') || (origin.value === 'face') || (origin.value === 'trinidad')) {
        return 'user';
      }
    }
    return 'user';
  }

  onClickContactoEditar = () => {
    this.setState({ isOpenModalContactEdit: true });
  }

  translateContract = (value) => {
    if (value === 'fixedTerm') {
      return { value: 'fixedTerm', label: 'Plazo fijo' };
    }

    if (value === 'undefined') {
      return { value: 'undefined', label: 'Indefenido' };
    }

    return null;
  }

  startEdit = () => {
    this.setState({ editField: false, showButton: true });
  }

  findValueWithClassForStatus = (value) => {
    if (value === 'pending') {
      return { class: 'badge_color_yellow badge', label: 'Pendiente' };
    }
    if (value === 'opened') {
      return { class: 'badge_color badge', label: 'Abierto' };
    }
    if (value === 'closed') {
      return { class: 'badge_color_red badge', label: 'Cerrado' };
    }
    return { class: 'badge_color_yellow badge', label: 'Pendiente' };
  }

  toggle = (tab) => {
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  onChangeActivity = key => e => {
    let target = e.target;
    this.setState(prevState => {
      let activity = { ...prevState.activity };
      activity[key] = target.value;
      return { activity };
    });
  };

  setActivityDescription = description => {
    this.setState(prevState => ({
      activity: { ...prevState.activity, description }
    }));
  };

  onChangeInput = key => (e) => {
    if ((key === 'names')
      || (key === 'paternalSurname')
      || (key === 'maternalSurname')
      || (key === 'companyName')
      || (key === 'concessionaire')
      || (key === 'street')
      || (key === 'email')
      || (key === 'clientActivity')
      || (key === 'numberOfFees')
      //nuevos campos
      || (key === 'nacionality')
      || (key === 'brand')
      || (key === 'model')
      || (key === 'year')
      || (key === 'term')
      || (key === 'cae')
      || (key === 'channelName')
      || (key === 'dealerName')
      || (key === 'sellerName')
      || (key === 'branchName')
      || (key === 'trinidadCode')
      || (key === 'carState')
      || (key === 'antiquity')
      || (key === 'dateState')
      || (key === 'evaluationState')
      //fin nuevos campos
    ) {
      this.setState({ [key]: e.target.value });
    } else if (key === 'carPatent') {
      this.setState({ [key]: e.target.value.replace(/[^A-Z0-9\s]/gi, '').trim() });
    } else if ((key === 'companyRUT') || (key === 'rut')) {
      this.setState({ [key]: setRUTFormat(e.target.value.trim()) });
    } else if ((key === 'officePhone') || (key === 'workPhone') || (key === 'phone')) {
      let justNumbers = e.target.value.replace(/[^0-9\s]/gi, '').trim();
      this.setState({ [key]: justNumbers });
    } else if ((key === 'rent')
      || (key === 'priceVehicle')
      || (key === 'initialPayment')
      || (key === 'numberOfFees')
      || (key === 'feeToPay')
      || (key === 'averageIncome')) {
      this.setState({ [key]: e.target.value.replace(/[^$0-9\s]/gi, '') });
    } else {
      this.setState({ [key]: e });
    }
  }

  onChangeToDoList = key => (e) => {
    const { _id, toDo } = this.state;
    this.setState({ disableToDo: true });

    if (key === 'customerContacted') {
      toDo.payload.customerContacted = e.target.checked;
    }

    if (key === 'completedForm') {
      toDo.payload.completedForm = e.target.checked;
    }

    if (key === 'FAndIDerivative') {
      toDo.payload.FAndIDerivative = e.target.checked;
    }

    if (key === 'clientVisit') {
      toDo.payload.clientVisit = e.target.checked;
    }

    if (this.state.isAdmin) {
      this.props.updateQuotations(_id, toDo, () => {
        this.props.getQuotationById(_id, (body) => {
          this.assignValueOnState(body);
          this.setState({ disableToDo: false });
        });
      });
    } else {
      this.props.updateQuotationsMe(_id, toDo, () => {
        this.props.getQuotationByIdMe(_id, (body) => {
          this.assignValueOnState(body);
          this.setState({ disableToDo: false });
        });
      });
    }
  }

  onChangeAddressPersonal = key => (e) => {
    const address = { ...this.state.address };
    if (key === 'street') {
      address.street = e.target.value;
      this.setState({ address });
    } else if (key === 'addressRegion') {
      if (e) {
        address.region = {
          value: e.value,
          label: e.label,
        };
        address.commune = null;
        this.setState({ address });
        this.props.getCommuns({ region: e.value }, (body) => {
          address.coptions = body;
          this.setState({ address });
        });
      } else {
        address.region = null;
        address.commune = null;
        address.coptions = [];
        this.setState({ address });
      }
    } else {
      address.commune = e;
      this.setState({ address });
    }
  }

  justReplace = (string) => {
    let withNewLine = '';
    withNewLine = string.replace('↵', '\n');
    return withNewLine;
  }

  onSubmitNewQuotations = (e, requiresOffers = false) => {
    if (e) {
      e.preventDefault();
    }

    const {
      _id,
      client,
      executive,
      haveProperty,
      haveVehicle,
      carPatent,
      companyName,
      companyRUT,
      birthdate,
      typeContract,
      typeVehicle,
      priceVehicle,
      initialPayment,
      numberOfFees,
      feeToPay,
      civilStatus,
      dateEntry,
      names,
      email,
      phone,
      paternalSurname,
      maternalSurname,
      rut,
      rent,
      address,
      concessionaire,
      workSituation,
      workPhone,
      officePhone,
      origin,
      fixedIncome,
      variableIncome,
      averageIncome,
      clientActivity,
    } = this.state;

    const isAdmin = isUserAllowed('admin') || isUserAllowed('manager');

    const today = new Date();

    if ((birthdate !== '') && (moment(birthdate).year() > moment(today).year())) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Error ingrese una fecha de nacimiento valida.',
      });

      return;
    }

    if (isAdmin) {
      if (executive === null) {
        BasicNotification.show({
          color: 'danger',
          title: 'Atención',
          message: 'Debe seleccionar un ejecutivo.',
        });

        return;
      }
    }

    if (names === '') {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe ingresar un nombre del cliente.',
      });

      return;
    }

    if (paternalSurname === '') {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe ingresar un apellido paterno del cliente.',
      });

      return;
    }

    if (rut === '') {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe ingresar el rut del cliente.',
      });

      return;
    }

    if (validateEmail(email) === false) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe ingresar un email valido.',
      });

      return;
    }

    if (!workSituation) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Porfavor es necesario seleccionar una Situación Laboral.',
      });

      return;
    } else if ((workSituation.value === 'independent') && ((!clientActivity) || (clientActivity === ''))) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Porfavor es necesario indicar la actividad del cliente.',
      });
      return;
    }

    if (((address.street !== null) && (address.street !== '')) || (address.region !== null) || (address.commune !== null)) {
      if ((address.street === '') || (address.region === null) || (address.commune === null)) {
        BasicNotification.show({
          color: 'danger',
          title: 'Atención',
          message: 'Debe ingresar todos los campos de la o las direcciones.',
        });
        return;
      }
    }

    if ((haveVehicle?.value === true) && (!carPatent)) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe ingresar la patente del vehiculo.',
      });

      return;
    }

    if (!typeVehicle) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe seleccionar un tipo de vehiculo.',
      });

      return;
    }

    if (!origin.value) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe seleccionar un origen.',
      });

      return;
    }

    this.sendData({
      _id,
      client,
      haveProperty: haveProperty.value,
      haveVehicle: haveVehicle.value,
      carPatent,
      companyName: companyName.trim(),
      companyRUT: companyRUT.replace(/[^K0-9\s]/gi, ''),
      birthdate,
      dateEntry,
      civilStatus,
      rent: String(rent).replace(/[^,0-9\s]/gi, ''),
      priceVehicle: String(priceVehicle).replace(/[^,0-9\s]/gi, ''),
      initialPayment: !initialPayment ? (initialPayment * 0.1) : String(initialPayment).replace(/[^,0-9\s]/gi, ''),
      numberOfFees: String(numberOfFees).replace(/[^,0-9\s]/gi, ''),
      feeToPay: String(feeToPay).replace(/[^,0-9\s]/gi, ''),
      workPhone,
      workSituation: workSituation.value,
      names: names.trim(),
      paternalSurname: paternalSurname ? paternalSurname.trim() : '',
      maternalSurname: maternalSurname ? maternalSurname.trim() : '',
      rut: rut.replace(/[^K0-9\s]/gi, ''),
      officePhone,
      email: email.trim(),
      phone: phone.trim(),
      address: ((address.street) && (address.commune) && (address.region)) ? address : undefined,
      fixedIncome: fixedIncome ? fixedIncome.value : undefined,
      variableIncome: variableIncome ? variableIncome.value : undefined,
      averageIncome: (averageIncome !== '') ? averageIncome.toString().replace(/[^,0-9\s]/gi, '') : '',
      clientActivity: clientActivity ? clientActivity.trim() : '',
      origin: origin.value,
      executive: executive.value,
      concessionaire: concessionaire ? concessionaire.trim() : '',
      //nuevos campos
      CAE: parseFloat(this.state.cae),
      brand: this.state.brand,
      channelName: this.state.channelName,
      year: this.state.year,
      dealerName: this.state.dealerName,
      sellerName: this.state.sellerName,
      vehicleModel: this.state.model,
      firstExpirationDate: this.state.expirationDate,
      vehicleStatus: this.state.carState,
      typeVehicle: this.state.typeVehicle || typeVehicle.value,
      term: this.state.term,
      storeName: this.state.branchName,
      antiquity: this.state.antiquity,
      dateState: this.state.dateState,
      evaluationState: this.state.evaluationState,
      evaluationStatus: this.state.evaluationStatus,
      trinidadStatus: this.state.trinidadStatus,
      requiresOffers,
      nameEF: this.state.nameEF,
      isPort: this.state.isPort,
      financialProducts: this.state.financialProducts,
      financialProductsToImport: this.state.financialProductsToImport,
      originalFeeValue: this.state.originalFeeValue,
      totalPaidFees: this.state.totalPaidFees,
      licensePlate: this.state.licensePlate,
      originalCreditAmount: this.state.originalCreditAmount,
      originalPeriod: this.state.originalPeriod,
      description: this.state.description,
      ...(typeContract && { typeContract: typeContract.value })
    });
  }

  sendData = (data) => {
    if (data.action) {
      const updateQuotationsCallback = (body) => {
        this.setState({ evaluation: body.evaluation, trinidadCode: body.trinidadCode });
      };

      if (this.state.isAdmin) {
        this.props.updateQuotations(data._id, data, () => {
          this.props.getQuotationById(data._id, updateQuotationsCallback);
        });
      } else {
        this.props.updateQuotationsMe(data._id, data, () => {
          this.props.getQuotationByIdMe(data._id, updateQuotationsCallback);
        });
      }
    } else if (!data._id) {
      delete data._id;

      if (this.state.isAdmin) {
        this.props.createQuotations(data, (body) => {
          this.props.history.push(`/cotizaciones/${body._id}`);
        });
      } else {
        this.props.createQuotationsMe(data, (body) => {
          this.props.history.push(`/cotizaciones/${body._id}`);
        });
      }
    } else if (this.state.isAdmin) {
      this.props.updateQuotations(data._id, data, () => {
        this.props.getQuotationById(data._id, (quotationsInfo) => {
          this.setState({
            activities: quotationsInfo.activities,
            executive: quotationsInfo.executive ? { value: quotationsInfo.executive._id, label: `${quotationsInfo.executive.firstName} ${quotationsInfo.executive.lastName}` } : null,
          });
        });
      });
    } else {
      this.props.updateQuotationsMe(data._id, data, () => {
        this.props.history.push(`/cotizaciones/${data._id}`);
      });
    }

    this.setState({ editField: true, showButton: false });
  }

  onClickEditQuotation = quotationSelected => () => {
    this.setState({ isOpenModalE: true, quotationSelected });
  }

  onClickDeleteQuotations = quotationSelected => () => {
    this.setState({ isOpenModalD: true, quotationSelected });
  }

  onClickCustomerEvaluation = () => {
    if ((this.state.rent) && (this.state.typeVehicle) && (this.state.workSituation)) {
      const {
        _id,
      } = this.state;
      this.sendData({ _id, action: 'sendToTrinidad' });
    } else {
      this.setState({ isOpenEvaluateModal: true });
    }
  }

  onDelete = () => {
    const { quotationSelected } = this.state;
    this.props.deleteQuotations(quotationSelected, () => {
      this.setState({ isOpenModalD: false });
      this.props.history.push('/cotizaciones');
    });
  }

  onClickCloseQuotation = quotationSelected => () => {
    if (some(this.props.currentUser.roles, (e) => e === ROLES.admin)) {
      this.setState({ isOpenModalCloseQuotations: true, quotationSelected });
    } else if (some(this.props.currentUser.roles, (e) => e === ROLES.salesExecutiveSc || e === ROLES.firstContactExecutive)) {
      if (some(this.props.managements.entry, (e) => e.executive === this.props.currentUser._id)) {
        this.setState({ isOpenModalCloseQuotations: true, quotationSelected });
      } else {
        toast.error('El usuario debe crear al menos una gestión para cerrar caso');
      }
    } else {
      this.setState({ isOpenModalCloseQuotations: true, quotationSelected });
    }
  }

  onCloseCase = () => {
    const { quotationSelected } = this.state;
    const data = { action: 'close' };

    if (this.state.isAdmin) {
      this.props.updateQuotations(quotationSelected, data, () => {
        this.props.getQuotationById(quotationSelected, (quotationInfo) => {
          this.fillQuotationData(quotationSelected, quotationInfo);
        });
      });
    } else {
      this.props.updateQuotationsMe(quotationSelected, data, () => {
        this.props.getQuotationByIdMe(quotationSelected, (quotationInfo) => {
          this.fillQuotationData(quotationSelected, quotationInfo);
        });
      });
    }
  }

  fillQuotationData = (quotationSelected, quotationInfo) => {
    this.setState(prevState => ({
      idDetail: quotationSelected,
      _id: quotationSelected,
      names: quotationInfo?.client?.names || quotationInfo?.client?.companyName || '',
      paternalSurname: quotationInfo.client.paternalSurname,
      rut: quotationInfo.client.rut,
      email: quotationInfo.client.emails.length > 0 ? quotationInfo.client.emails[0].email : '',
      rent: (quotationInfo.rent) ? quotationInfo.rent : '',
      status: (quotationInfo.status) ? quotationInfo.status : '',
      phone: quotationInfo.client.phones[0],
      executive: quotationInfo.executive ? { value: quotationInfo.executive._id, label: `${quotationInfo.executive.firstName} ${quotationInfo.executive.lastName}` } : null,
      haveProperty: this.translatePropierty(quotationInfo?.haveProperty),
      haveVehicle: this.translatePropierty(quotationInfo?.haveVehicle),
      carPatent: quotationInfo.carPatent ? quotationInfo.carPatent : '',
      companyName: quotationInfo.companyName || '',
      companyRUT: setRUTFormat(quotationInfo.companyRUT),
      typeContract: this.translateContract(quotationInfo?.typeContract) || '',
      concessionaire: quotationInfo.concessionaire,
      workSituation: quotationInfo.workSituation ? quotationInfo.workSituation : null,
      fixedIncome: this.translatePropierty(quotationInfo?.fixedIncome),
      variableIncome: this.translatePropierty(quotationInfo?.variableIncome),
      averageIncome: quotationInfo?.averageIncome?.replace(/[^0-9\s]/gi, '').trim() || null,
      code: quotationInfo.code,
      trinidadCode: quotationInfo.trinidadCode || null,
      typeVehicle: this.translatePropierty(quotationInfo?.typeVehicle) || '',
      priceVehicle: quotationInfo?.priceVehicle || '',
      initialPayment: (quotationInfo.initialPayment) ? quotationInfo.initialPayment : '',
      numberOfFees: (quotationInfo.numberOfFees) ? quotationInfo.numberOfFees : '',
      feeToPay: (quotationInfo.feeToPay) ? quotationInfo.feeToPay : '',
      dateEntry: quotationInfo.dateEntry ? moment(quotationInfo.dateEntry).toDate() : '',
      workPhone: quotationInfo.workPhone,
      officePhone: quotationInfo.officePhone,
      activities: quotationInfo.activities,
      origin: { label: quotationInfo.origin, value: quotationInfo.origin },
      createdAt: quotationInfo.createdAt,
      client: quotationInfo.client._id,
      evaluation: quotationInfo.evaluation,
      //nuevos campos
      CAE: parseFloat(prevState.cae),
      brand: prevState.brand,
      channelName: prevState.channelName,
      year: prevState.year,
      dealerName: prevState.dealerName,
      sellerName: prevState.sellerName,
      vehicleModel: prevState.model,
      firstExpirationDate: prevState.expirationDate,
      vehicleStatus: prevState.carState,
      term: prevState.term,
      storeName: prevState.branchName,
      antiquity: prevState.antiquity,
      dateState: prevState.dateState,
      evaluationState: prevState.evaluationState,
      evaluationStatus: prevState.evaluationStatus,
      trinidadStatus: prevState.trinidadStatus,
      nameEF: prevState?.nameEF || '',
      isPort: prevState?.isPort || false,
      financialProducts: prevState?.financialProducts || '',
      financialProductsToImport: prevState?.financialProductsToImport || '',
      originalFeeValue: prevState?.originalFeeValue || '',
      totalPaidFees: prevState?.totalPaidFees || '',
      licensePlate: prevState?.licensePlate || '',
      originalCreditAmount: prevState?.originalCreditAmount || '',
      originalPeriod: prevState?.originalPeriod || '',
    }));
  }

  newWindow = link => () => {
    window.open(link, 'name', 'width=600,height=400');
  }

  toggleDeleteContacto = isOk => () => {
    if (isOk) {
      this.onDelete();
    } else {
      this.setState({ isOpenModalD: false });
    }
  }

  toggleEvaluateCustomer = () => () => {
    this.setState({ isOpenEvaluateModal: false });
  }

  toggleEditContacto = isOk => () => {
    if (isOk) {
      this.onSubmitNewQuotations();
    } else {
      this.setState({ isOpenModalE: false });
    }
  }

  toggleCloseQuotations = isOk => () => {
    if (isOk) {
      this.setState({ isOpenModalCloseQuotations: false });
      this.onCloseCase();
    } else {
      this.setState({ isOpenModalCloseQuotations: false });
    }
  }

  onChangeAddress = (key, index) => (e) => {
    const addresses = [...this.state.addresses];

    if (key === 'regions') {
      addresses[index][key] = e;
      addresses[index].commune = null;
      addresses[index].coptions = e ? e.communes : [];
      this.setState({ addresses });
    } else if (key === 'communes') {
      addresses[index][key] = e;
      this.setState({ addresses });
    } else {
      addresses[index][key] = e.target.value;
      this.setState({ addresses });
    }
  }

  onSubmitNewActivity = (e) => {
    e.preventDefault();
    const { _id } = this.state;

    const data = {
      action: 'addActivity',
      activity: { description: this.state.activity.description.trim() }
    };

    const updateQuotationsCallback = (quotationsInfo) => {
      let executiveOption = { value: quotationsInfo.executive._id, label: `${quotationsInfo.executive.firstName} ${quotationsInfo.executive.lastName}` }
      this.setState({
        activities: quotationsInfo.activities,
        executive: quotationsInfo.executive ? executiveOption : null,
        client: quotationsInfo.client.rut,
      });
    };

    this.setState({ isOpenModalAssignActivity: false });

    if (this.state.isAdmin || isUserAllowed(ROLES.purchaseAdvisorSc)) {
      this.props.updateQuotations(_id, data, () => {
        this.props.getQuotationById(_id, updateQuotationsCallback);
        this.props.getUsers({ all: true, roles: `${ADMIN_QUOTATION_ROLE_FILTER}, ${FIRST_SECOND_CONTACT_FILTER}` }, (body) => {
          this.setState({ users: body.map(user => ({ value: user._id, label: `${user.firstName} ${user.lastName}` })) });
        });
      });
    } else {
      this.props.updateQuotationsMe(_id, data, () => {
        this.props.getQuotationByIdMe(_id, updateQuotationsCallback);
      });
    }
  }

  onClickModalNewMailsReplays = () => {
    const NewMessage = {
      body: null,
      editor: null,
      attachments: [],
    };
    this.setState({ isOpenModalMessageMail: true, NewMessage });
  }

  toggleModalNewMessage = () => {
    this.setState({ isOpenModalMessageMail: false });
  };

  removeAttachment = e => () => {
    this.setState(prevState => {
      let NewMessage = { ...prevState.NewMessage };
      let aux = [];
      forEach(NewMessage?.attachments || [], (file, index) => {
        if (index !== e) aux.push(file);
      });
      NewMessage.attachments = aux;
      return { NewMessage };
    });
  }

  onChangeMessage = key => e => {
    let target = e.target;
    this.setState(prevState => {
      let NewMessage = { ...prevState.NewMessage };
      if (key === 'editor' || key === 'to' || key === 'cc') {
        NewMessage[key] = e;
      } else if (key === 'attachments' && target?.files?.length) {
        forEach(target.files, (file) => {
          NewMessage[key].push(file);
        });
      } else {
        NewMessage[key] = target.value;
      }
      return { NewMessage };
    });
  };

  onSubmitNewMailsReplays = (e) => {
    if (e) {
      e.preventDefault();
    }
    const { _id, NewMessage } = this.state;
    let message;
    if (this.mailRef) {
      message = this.mailRef.getTextHtml();
    }
    if (!_id) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Se debe crear la cotización antes de responder correos.',
      });
      return;
    }
    if (!message) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe ingresar un mensaje para responder el correo.',
      });
      return;
    }

    if (!NewMessage.to) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe ingresar el correo destinatario.',
      });
      return;
    }

    const data = {
      action: 'addMessage',
      to: NewMessage.to.value,
      cc: NewMessage.cc,
      body: message,
    };
    if (NewMessage.attachments) {
      let totalSize = 0;
      map(NewMessage.attachments, (file) => {
        totalSize += file.size;
      });
      if (totalSize > 5000000) {
        BasicNotification.show({
          color: 'danger',
          title: 'Atención',
          message: 'Los archivos adjuntos no pueden superar los 5 MB',
        });
        return;
      }
      data.attachments = NewMessage.attachments;
    }

    if (this.state.isAdmin || isUserAllowed(ROLES.purchaseAdvisorSc)) {
      this.props.updateQuotations(_id, data, () => {
        this.setState({ isOpenModalMessageMail: false });
        this.props.getQuotationById(_id, (quotationsInfo) => {
          this.setState({
            messages: quotationsInfo.messages,
            executive: quotationsInfo.executive ? { value: quotationsInfo.executive._id, label: `${quotationsInfo.executive.firstName} ${quotationsInfo.executive.lastName}` } : null,
            client: quotationsInfo.client.rut,
          });
        });
        this.props.getUsers({ all: true, roles: `${ADMIN_QUOTATION_ROLE_FILTER}, ${FIRST_SECOND_CONTACT_FILTER}` }, (body) => {
          this.setState({ users: map(body, user => ({ value: user._id, label: `${user.firstName} ${user.lastName}` })) });
        });
      });
    } else {
      this.props.updateQuotationsMe(_id, data, () => {
        this.setState({ isOpenModalMessageMail: false });
        this.props.getQuotationByIdMe(_id, (quotationsInfo) => {
          this.setState({
            messages: quotationsInfo.messages,
            executive: quotationsInfo.executive ? { value: quotationsInfo.executive._id, label: `${quotationsInfo.executive.firstName} ${quotationsInfo.executive.lastName}` } : null,
            client: quotationsInfo.client.rut,
          });
        });
      });
    }
  }

  toggleModalAssignActivity = () => {
    this.setState({ isOpenModalAssignActivity: false });
  };

  toggleModalContactEdit = isOk => () => {
    const { id } = this.props.match.params;
    if (isOk) {
      this.props.getContactByRut(this.state.rutCrm, () => {
        this.setState({ isOpenModalContactEdit: false });
      });
      if (this.state.isAdmin || isUserAllowed(ROLES.purchaseAdvisorSc)) {
        this.props.getQuotationById(id, (quotationInfo) => {
          this.assignValueOnState(quotationInfo);
        });
      } else {
        this.props.getQuotationByIdMe(id, (quotationInfo) => {
          this.assignValueOnState(quotationInfo);
        });
      }
    } else {
      this.setState({ isOpenModalContactEdit: false });
    }
  }

  handleActivityModalOpen = () => {
    this.setState((prevState) => ({ isOpenModalAssignActivity: !prevState.isOpenModalAssignActivity }));
  }

  onClickModalNewActivity = () => {
    const activity = {
      description: null,
      executive: null,
    };
    this.setState({ isOpenModalAssignActivity: true, activity });
  }

  statusShower = (trinidad, web) => {
    let status;
    if (trinidad) {
      status = capitalize(trinidad);
    } else if (web) {
      status = `${web.status}`;
    } else {
      status = '';
    }
    return status;
  };

  getEvaluationStatus = () => {
    const {
      clientEvaluation,
      evaluationStatus,
      trinidadStatus,
    } = this.state;
    let comment;
    let code;

    if (clientEvaluation) {
      code = `#${clientEvaluation}`;
    }

    return (
      <Fragment>
        {
          code && (
            <div className="profile_info col-md-4">
              <FormGroup className="details_profile_columned">
                <Label className="label_autofin" for="profile">Código</Label>
                <span>{code}</span>
              </FormGroup>
            </div>
          )
        }
        {(!this.props.loadingQuotations) &&
          <div className="profile_info col-md-4">
            <FormGroup className="details_profile_columned">
              <Label className="label_autofin" for="profile">Estado</Label>
              <span>{this.statusShower(trinidadStatus, evaluationStatus)}</span>
            </FormGroup>
          </div>}
        {
          comment && (
            <div className="profile_info col-md-12">
              <FormGroup className="details_profile_columned">
                <Label className="label_autofin" for="profile">Comentario</Label>
                <span>{comment}</span>
              </FormGroup>
            </div>
          )
        }
      </Fragment>
    );
  }

  getStatusForm = () => {
    const status = 'enviado';

    return (
      <Fragment>
        <div className="profile_info col-md-3">
          <FormGroup className="details_profile_columned">
            <Label className="label_autofin" for="profile">Estado</Label>
            <span>{status}</span>
          </FormGroup>
        </div>
        <div className="profile_info col-md-4">
          <FormGroup className="details_profile_columned">
            <Label className="label_autofin" for="profile">Fecha envio formulario</Label>
            <span>{this.state.sentInformationRequest}</span>
          </FormGroup>
        </div>
        <div className="profile_info col-md-4">
          <FormGroup className="details_profile_columned">
            <Label className="label_autofin" for="profile">Fecha respuesta cliente</Label>
            <span>{this.state.sentClientResponse || 'sin responder'}</span>
          </FormGroup>
        </div>
      </Fragment>
    );
  }

  setMailRef = (element) => {
    this.mailRef = element;
  }

  closeMakeCall = number => () => {
    const { anexo, denwaPassword } = this.props.currentUser;
    if (number) {
      this.props.makeCall({
        phone: number,
        user: {
          anexo,
          denwaPassword
        }
      });
    }
    this.setState({ callPhone: null, isMakeCallOpen: false });
  }

  openMakeCall = (e) => {
    this.setState({ callPhone: e, isMakeCallOpen: true });
  }

  setHistoryTab = (historyTab) => {
    this.setState({ historyTab })
  }

  setStateValue = (key, value) => {
    this.setState({ [key]: value });
  }

  render() {
    const { activeTab } = this.state;
    const {
      contact,
      contracts,
      cargandoContact,
      cargandoContract,
      loadingQuotations,
      disableCloseQuotations,
      settings,
    } = this.props;
    const today = moment().format('DD/MM/YYYY');
    let edad = 0;
    contact && (edad = moment(today).year() - moment(contact.birthdate).year());
    const { id, rut } = this.props.match.params;

    const statusTranslate = this.findValueWithClassForStatus(this.state.status);

    let subject = '';
    let formBody = '';
    const optionsEC = map(this.props.civilStatus, typ => ({ value: typ.value, label: typ.label }));

    if (parseInt(this.state.rut, 10) > 500000000) {
      subject = `AUTOFIN%20Cotización%20%23%20${this.state.code}%20evaluación%20crédito%20automotriz`;

      formBody = `Si%20%20quieres%20%20cotizar%20%20como%20%20empresa:%0D%0A

      -RUT%20%20Empresa:%0D%0A
      -Adjuntar%20%20carpeta%20%20tributaria.
      %0D%0A
      %0D%0A`;
    }

    const createEmail = `https://mail.google.com/mail/?view=cm&fs=1&to=${this.state.emailClienteCrm}&su=${subject}&body=${formBody}`;

    return (
      <div className="dashboard container">
        {loadingQuotations && <LoadingScreen />}
        <Toaster />
        <DModal
          title="Atención"
          color="danger"
          message="¿Esta seguro que desea borrar este registro?"
          isOpen={this.state.isOpenModalD}
          toggle={this.toggleDeleteContacto}
        />
        <EvaluateModal
          title="Atención"
          color="danger"
          message="Para poder realizar la evaluación se necesita los siguientes campos:"
          isOpen={this.state.isOpenEvaluateModal}
          workSituation={this.state.workSituation}
          rent={this.state.rent}
          typeVehicle={this.state.typeVehicle}
          toggle={this.toggleEvaluateCustomer}
        />
        <CloseQuotationsModal
          title="Advertencia"
          color="warning"
          message="¿Esta seguro que desea Cerrar esta cotización?"
          isOpen={this.state.isOpenModalCloseQuotations}
          toggle={this.toggleCloseQuotations}
        />
        <EModal
          title="Atención"
          color="primary"
          message="¿Esta seguro que desea editar este registro?"
          isOpen={this.state.isOpenModalE}
          toggle={this.toggleEditContacto}
        />
        <ModalContactoEdit
          isOpen={this.state.isOpenModalContactEdit}
          rutToFind={this.state.rutCrm}
          toggle={this.toggleModalContactEdit}
        />
        <MakeCall
          phone={this.state.callPhone}
          toggle={this.closeMakeCall}
          visible={this.state.isMakeCallOpen}
        />
        <Row>
          <div className="col-md-7">
            <Card className="cardo_botton" style={{ height: 'auto' }}>
              <CardBody style={{ padding: '0px 10px' }}>
                <form className="form form--horizontal" onSubmit={this.onSubmitNewQuotations}>
                  <div className="profile_casos profile_casos_detail">
                    <div className='crm-quotation-info-container'>
                      <div className='crm-top-quotations'>
                        <div style={{ display: 'flex', width: '80%' }}>
                          <div className={`new_lnr lnr-${this.findIcon(this.state.origin)} font-case-details`} style={{ height: '40px' }} />
                          <div className="head_title_to_case_detail" style={{ flexDirection: 'column', marginLeft: '5%', justifyContent: 'center' }}>
                            <h5>Cotización <span>{!rut && (`#${this.state.code}`)}</span></h5>
                            <span className={statusTranslate.class}>{statusTranslate.label}</span>
                          </div>
                        </div>
                        {this.state.createdAt &&
                          <div >
                            <h5 style={{ fontWeight: '600' }}>Creado</h5>
                            <span>{moment(this.state.createdAt).format('DD/MM/YYYY, h:mm:ss')}</span>
                          </div>
                        }
                      </div>

                      <div className='crm-quotations-subtitle'>
                        <div className='crm-subtitle'>Datos personales</div>
                        <div className="af-gold-line" />
                      </div>

                      <PersonalData
                        onChangeAddressPersonal={this.onChangeAddressPersonal}
                        onChangeInput={this.onChangeInput}
                        optionsEC={optionsEC}
                        values={this.state}
                      />

                      <div className='crm-quotations-subtitle'>
                        <div className='crm-subtitle'>Datos cotización</div>
                        <div className="af-gold-line" />
                      </div>

                      <ListingData onChangeInput={this.onChangeInput} values={this.state} isNew={this.state.new} origins={this.props.origins} />

                      <div className='crm-quotations-subtitle'>
                        <div className='crm-subtitle'>Datos laborales</div>
                        <div className="af-gold-line" />
                      </div>

                      <LaborData onChangeInput={this.onChangeInput} values={this.state} isNew={this.state.new} />

                      <div className='crm-quotations-subtitle'>
                        <div className='crm-subtitle'>Datos Portabilidad</div>
                        <div className="af-gold-line" />
                      </div>

                      <PortabilityData onChangeInput={this.onChangeInput} values={this.state} />

                      {
                        this.state.new && (
                          <div className="col-md-12">
                            <Button className="asignar" onClick={this.cancelEdit}>Cancelar</Button>{' '}
                            <Button
                              className="asignar just_this"
                              type="submit"
                              id="added"
                            >Guardar
                            </Button>
                          </div>
                        )
                      }
                    </div>
                  </div>
                </form>
              </CardBody>
            </Card>
            {this.state.messages && !this.state.isPort && (
              <MailsContents
                ref={this.setMailRef}
                messages={this.state.messages}
                id={this.state._id}
                sourceMail={settings?.customerService?.email || ''}
                loading={disableCloseQuotations}
                onClickModalNewMailsReplays={this.onClickModalNewMailsReplays}
                toggleModalNewMessage={this.toggleModalNewMessage}
                NewMessage={this.state.NewMessage}
                onChangeMessage={this.onChangeMessage}
                isOpenModalMessageMail={this.state.isOpenModalMessageMail}
                onSubmit={this.onSubmitNewMailsReplays}
                emailArrayToMailsContents={this.state.emailArrayToMailsContents}
                removeAttachment={this.removeAttachment}
              />
            )}
          </div>
          <div className="col-md-5">
            <Card className="cardo_botton" style={{ height: 'auto' }}>
              <CardBody style={{ padding: '0px 10px' }}>
                <div className="profile_casos card col-md-12" style={{ flexWrap: 'wrap', justifyContent: 'flex-start', padding: '10px 0px' }}>
                  <div className="profile_info col-md-12" style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {loadingQuotations && <Skeleton count={1} height={40} />}
                    <div className="col-md-4 mt-3">
                      <h5 className="label_autofin">{this.state.namesCrm} {this.state.paternalCrm}</h5>
                      <h5>{setRUTFormat(this.state.rutCrm)}</h5>
                    </div>

                    {!isUserAllowed(ROLES.auditor) &&
                      <div className="profile_info_calls col-md-8" style={{ justifyContent: 'flex-start', marginTop: '2%' }}>
                        <Row>
                          {!isUserAllowed(ROLES.purchaseAdvisorSc) &&
                            <Button
                              className="asignar button_details button_profile_detail"
                              type="submit"
                              id="added"
                              onClick={this.onClickCloseQuotation(this.state.idDetail)}
                            >
                              Cerrar cotización
                            </Button>
                          }
                          <Button
                            className="asignar button_details button_profile_detail"
                            type="submit"
                            onClick={this.newWindow(createEmail)}
                            id="added"
                          >
                            <span target="_blank" style={{ color: '#646777' }}>Enviar correo</span>
                          </Button>
                          {!this.state.clientEvaluation &&
                            <Button
                              className="asignar button_details button_profile_detail mt-2"
                              type="submit"
                              onClick={this.onClickCustomerEvaluation}
                              id="added"
                            >
                              <span style={{ color: '#646777' }}>Evaluar cliente</span>
                            </Button>
                          }
                        </Row>
                      </div>}
                  </div>
                  {id && !isUserAllowed(ROLES.auditor) &&
                    <GestionComponent
                      onClickModalNewActivity={this.onClickModalNewActivity}
                      handleActivityModalOpen={this.handleActivityModalOpen}
                      handleGetComponentData={this.handleGetComponentData}
                      setActivityDescription={this.setActivityDescription}
                      updateQuotation={this.onSubmitNewQuotations}
                      getAllManagements={this.props.getAllManagements}
                      getEvaluationStatus={this.getEvaluationStatus}
                      handleNewActivity={this.onSubmitNewActivity}
                      onChangeToDoList={this.onChangeToDoList}
                      getStatusForm={this.getStatusForm}
                      updateQuotations={this.props.updateQuotationMany}
                      loadingReasing={this.props.loadingReasing}
                      loadingActivity={disableCloseQuotations}
                      quotationId={id}
                      contact={contact}
                      values={this.state}
                      setStateValue={this.setStateValue}
                    />
                  }
                </div>
              </CardBody>
            </Card>

            {id &&
              <Card className='crm-management-history-card-container'>
                <CardBody>
                  <div className='crm-history-tabs'>
                    {isOptionAllowed([...FIRST_SECOND_CONTACT, 'admin']) &&
                      <button
                        className={`crm-history-tab ${this.state.historyTab === '1' && 'crm-tab-active'}`}
                        onClick={() => this.setHistoryTab('1')}
                      >
                        Historial de Gestiones
                      </button>
                    }
                    <button
                      className={`crm-history-tab ${this.state.historyTab === '2' && 'crm-tab-active'}`}
                      onClick={() => this.setHistoryTab('2')}
                    >
                      Historial de Actividades
                    </button>
                  </div>
                  {isOptionAllowed([...FIRST_SECOND_CONTACT, 'admin']) &&
                    <ManagementHistoryComponent
                      quotationId={id}
                      hidden={this.state.historyTab === '2'}
                      getAllManagements={this.props.getAllManagements}
                    />
                  }
                  <NewActivityComponent activities={this.state.activities} hidden={this.state.historyTab === '1'} />
                </CardBody>
              </Card>}


            <Card style={{ height: '40%' }}>
              <CardBody style={{ padding: '0px' }}>
                <div className="tabs tabs--bordered-bottom" style={{ overflowX: 'hidden', height: '100%' }}>
                  <div className="tabs__wrap">
                    <Nav tabs className="w_o_border">
                      <NavItem style={{ width: '33%' }}>
                        <NavLink
                          style={{ width: 'auto' }}
                          className={`crm-tabs-title ${classnames({ active: activeTab === '1' })}`}
                          onClick={() => {
                            this.toggle('1');
                          }}
                        >
                          Datos cliente
                        </NavLink>
                      </NavItem>
                      <NavItem style={{ width: '33%' }}>
                        <NavLink
                          style={{ width: 'auto' }}
                          className={`crm-tabs-title ${classnames({ active: activeTab === '2' })}`}
                          onClick={() => {
                            this.toggle('2');
                          }}
                        >
                          Productos y documentos
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={activeTab} >
                      <TabPane tabId="1">
                        <div className='crm-lateral-personal-data'>
                          <Row className="ml-3 mb-2">
                            <Col>
                              <span className="datos-personales">Datos Personales</span>
                              {id && contact && !isUserAllowed(ROLES.auditor) && (
                                <Button
                                  className="asignar button_details button_profile_detail ml-2"
                                  onClick={this.onClickContactoEditar}
                                  id="added"
                                >
                                  Editar
                                </Button>
                              )}
                            </Col>
                          </Row>
                          {
                            contact
                              ? (
                                <Row className="ml-3 mb-2 ">
                                  <Col md={6}>
                                    <div>
                                      <span className="span-title">
                                        RUT
                                      </span>
                                      <br />
                                      <span>
                                        {contact
                                          ? setRUTFormat(contact.rut)
                                          : '-'
                                        }
                                      </span>
                                    </div>
                                    <div>
                                      <span className="span-title">
                                        Teléfonos
                                      </span>
                                      <br />
                                      <span>
                                        {contact?.phones?.length
                                          ? map(contact.phones, phone => (
                                            <button className="phone-link" key={`${phone.code}${phone.number}`} onClick={() => this.openMakeCall(phone)}>
                                              <Icon path={mdiPhone} size={0.65} />
                                              {`${phone.code} - ${phone.number}`}
                                              <br />
                                            </button>
                                          )) : '-'
                                        }
                                      </span>
                                    </div>
                                    <div>
                                      <span className="span-title">
                                        Región
                                      </span>
                                      <br />
                                      {(contact?.addresses?.length)
                                        ? map(contact.addresses, (address, index) => (<div key={index}><span>{`${index + 1}.- ${(address.region) ? address.region.label : ''}`}</span></div>))
                                        : '-'
                                      }
                                    </div>
                                    <div>
                                      <span className="span-title">
                                        Comuna
                                      </span>
                                      <br />
                                      <span>
                                        {(contact?.addresses?.length)
                                          ? map(contact.addresses, (address, index) => (<div key={`address-${index}`}><span>{`${index + 1}.- ${(address.commune) ? address.commune.label : ''}`}</span></div>))
                                          : '-'
                                        }
                                      </span>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div>
                                      <span className="span-title">
                                        Fecha de Nacimiento
                                      </span>
                                      <br />
                                      <span>
                                        {contact?.birthdate
                                          ? <span>{moment(contact.birthdate).format('DD/MM/YYYY')}</span>
                                          : '-'
                                        }
                                      </span>
                                    </div>
                                    <div>
                                      <span className="span-title">
                                        Email
                                      </span>
                                      <br />
                                      <span>
                                        {contact?.emails?.length ? map(contact.emails, item => item.email && <span key={item.email}>{`${item.email}`} <br /> </span>)
                                          : '-'
                                        }
                                      </span>
                                    </div>
                                    <div>
                                      <span className="span-title">
                                        Renta
                                      </span>
                                      <br />
                                      <span>
                                        {contact?.rent
                                          ? contact.rent
                                          : '0'
                                        }
                                      </span>
                                    </div>
                                    <div>
                                      <span className="span-title">
                                        Edad
                                      </span>
                                      <br />
                                      <span>
                                        {contact?.birthdate
                                          ? <span>{edad}</span>
                                          : '-'
                                        }
                                      </span>
                                    </div>
                                  </Col>
                                  <Col>
                                    <div>
                                      <span className="span-title">
                                        Dirección
                                      </span>
                                      <br />
                                      <span>
                                        {contact?.addresses?.length > 1
                                          ? map(contact.addresses, (address, index) => (<div key={`${index}-address`}><span>{`${index + 1}.- ${address.street}`}</span></div>))
                                          : '-'
                                        }
                                      </span>
                                    </div>
                                  </Col>
                                </Row>
                              )
                              : (
                                (cargandoContact) && (
                                  <Row className="ml-3 mb-2">
                                    <Col>
                                      <Skeleton count={4} height={40} />

                                    </Col>
                                    <Col>
                                      <Skeleton count={4} height={40} />
                                    </Col>
                                    <Col>
                                      <Skeleton count={1} height={40} />
                                    </Col>
                                  </Row>
                                )
                              )
                          }
                          {
                            (!contact) && (
                              <Row className="ml-3 mb-2">
                                <Col>Sin Registros</Col>
                              </Row>
                            )
                          }
                        </div>
                      </TabPane>
                      <TabPane tabId="2">
                        <div className='crm-lateral-personal-data'>
                          {this.state.signedDoc &&
                            <div className='crm-s3-docs'>
                              <span className="crm-doc-title">Documento Firmado</span>
                              <Col className="ml-4 mb-4 crm-col">
                                <div>
                                  <button
                                    title="Descargar"
                                    style={{ marginLeft: '10px', display: 'inline-block', lineHeight: '1' }}
                                    onClick={this.handleSavePDF}
                                    target="_blank"
                                  >
                                    <Icon path={mdiDownloadOutline} size="15px" />
                                    Documento Autofin Portabilidad
                                  </button>
                                </div>
                              </Col>
                            </div>
                          }
                          {!cargandoContract && contracts?.length ?
                            map(contracts, contract => (
                              <div>
                                <Row className="case-rectangle">
                                  <Col className="ml-4" sm={4} xs={4} md={4}>
                                    <div>
                                      <span className="span-title">Producto</span>
                                    </div>
                                    <div>
                                      <span>{contract?.NombreProducto?.toUpperCase() || ''}</span>
                                    </div>
                                  </Col>
                                  <Col sm={2} xs={2} md={2}>
                                    <div>
                                      <span className="span-title">ID</span>
                                    </div>
                                    <div>
                                      <span>{contract?.id ? `#${contract.id}` : ''}</span>
                                    </div>
                                  </Col>
                                  <Col sm={5} xs={5} md={5}>
                                    <Row>
                                      <Col>
                                        <div>
                                          <span className="span-title">Vehículo</span>
                                        </div>
                                        <div>
                                          <span>{`${contract?.Modelo || ''}`}</span>
                                        </div>
                                      </Col>
                                      <Col>
                                        <div>
                                          <span className="span-title">Marca</span>
                                        </div>
                                        <div>
                                          <span>{`${contract?.Marca || ''}`}</span>
                                        </div>
                                      </Col>
                                      <Col>
                                        <div>
                                          <span className="span-title">Año</span>
                                        </div>
                                        <div>
                                          <span>{`${contract?.AnnoVehiculo || ''}`}</span>
                                        </div>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col className="ml-4">
                                    - Certificado Tabla Desarrollo<a className="button-icon-light small"
                                      title="Descargar"
                                      style={{ marginLeft: '10px', display: 'inline-block', lineHeight: '1' }}
                                      href={`${BATCH_API}/aprcImprimirCertTablaDesarrolloPDFCRM.aspx?${contract ? contract.Id : ''}`}
                                      target="_blank"
                                      download >
                                      <Icon path={mdiDownloadOutline} size="15px" />
                                    </a>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col className="ml-4">
                                    - Informe de Cuotas<a
                                      className="button-icon-light small"
                                      title="Descargar"
                                      style={{ marginLeft: '10px', display: 'inline-block', lineHeight: '1' }}
                                      href={`${BATCH_API}/aprcImprimirInformeCuotasPDFCRM.aspx?${contract ? contract.Id : ''}`}
                                      target="_blank"
                                      download
                                    >
                                      <Icon path={mdiDownloadOutline} size="15px" />
                                    </a>
                                  </Col>
                                </Row>
                                <Row style={{ borderBottom: '1px solid #E5E5E6' }}>
                                  <Col className="ml-4">
                                    - Copia Contrato<a
                                      className="button-icon-light small"
                                      title="Descargar"
                                      style={{ marginLeft: '10px', display: 'inline-block', lineHeight: '1' }}
                                      href={`${BATCH_API}/aContratoAutoWSCRM.aspx?${contract ? contract.Id : ''}`}
                                      target="_blank"
                                      download
                                    >
                                      <Icon path={mdiDownloadOutline} size="15px" />
                                    </a>
                                  </Col>
                                </Row>
                              </div>
                            ))
                            : ''}
                          {!cargandoContract && !contracts.length && <Col>Sin Registros</Col>}
                          {cargandoContract && <Col>Obteniendo Registros</Col>}
                        </div>
                      </TabPane>
                    </TabContent>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </Row>
      </div>
    );
  }
}

QuotationDetalle.propTypes = {
  loadingReasing: PropTypes.bool,
  cargandoContact: PropTypes.bool,
  loadingQuotations: PropTypes.bool,
  updateQuotationMany: PropTypes.bool,
  disableCloseQuotations: PropTypes.bool,
  location: PropTypes.object,
  settings: PropTypes.object,
  origins: PropTypes.array,
  contracts: PropTypes.array,
  civilStatus: PropTypes.array,
  managements: PropTypes.shape({
    entry: PropTypes.arrayOf(
      PropTypes.shape({
        executive: PropTypes.string,
      })
    ),
  }),
  currentUser: PropTypes.shape({
    _id: PropTypes.string,
    anexo: PropTypes.string,
    denwaPassword: PropTypes.string,
    roles: PropTypes.array,
  }),
  getMe: PropTypes.func,
  makeCall: PropTypes.func,
  setTitle: PropTypes.func,
  getUsers: PropTypes.func,
  getRegions: PropTypes.func,
  getOrigins: PropTypes.func,
  getCommuns: PropTypes.func,
  getSettings: PropTypes.func,
  getCivilStatus: PropTypes.func,
  getContactByRut: PropTypes.func,
  getQuotationById: PropTypes.func,
  updateQuotations: PropTypes.func,
  getContractByRut: PropTypes.func,
  deleteQuotations: PropTypes.func,
  createQuotations: PropTypes.func,
  getAllManagements: PropTypes.func,
  getSignedDocumentQuotation: PropTypes.func,
  createQuotationsMe: PropTypes.func,
  updateQuotationsMe: PropTypes.func,
  getQuotationByIdMe: PropTypes.func,
  passGenerated: PropTypes.shape({ password: PropTypes.string }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
      rut: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({ push: PropTypes.func }),
  contact: PropTypes.shape({
    deleted: PropTypes.bool,
    _id: PropTypes.string,
    rent: PropTypes.number,
    rut: PropTypes.string,
    type: PropTypes.string,
    emails: PropTypes.array,
    phones: PropTypes.array,
    names: PropTypes.string,
    addresses: PropTypes.array,
    createdAt: PropTypes.string,
    birthdate: PropTypes.string,
    updatedAt: PropTypes.string,
    civilStatus: PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string
    }),
    maternalSurname: PropTypes.string,
    nationality: PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string
    }),
    paternalSurname: PropTypes.string,
    sex: PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string
    }),
    trinidadCode: PropTypes.string
  })
};

const mapStateToProps = ({ cases, contacts, users, quotations, resources, management }) => ({
  update: contacts.update,
  contact: contacts.contact,
  contracts: contacts.contracts,
  cargandoContact: contacts.cargando,
  cargandoContract: contacts.cargandoContract,
  users: users.collection,
  currentUser: users.currentUser,
  types: cases.types,
  disable: cases.disable,
  caseInfo: cases.caseInfo,
  subtypes: cases.subtypes,
  disableCreate: cases.disableCreate,
  disableCloseCase: cases.disableCloseCase,
  origins: resources.origins,
  regions: resources.Regions,
  Communs: resources.Communs,
  settings: resources.settings,
  civilStatus: resources.civilStatus,
  loadingSetting: resources.loadingSetting,
  managements: management.managements,
  quotationInfo: quotations.quotationInfo,
  loadingReasing: quotations.loadingReasing,
  quotationCreated: quotations.quotationCreated,
  loadingQuotations: quotations.loadingInfoQuotations,
  disableCloseQuotations: quotations.disableCloseQuotations,
});

const mapDispatchToProps = {
  getSettings,
  getMe,
  getCasesIdMe,
  setTitle: changeTitleAction,
  getAllTypesCases,
  getAllSubTypesCases,
  deleteCase,
  getRegions,
  getCommuns,
  updateCase,
  getCivilStatus,
  createCase,
  deleteQuotations,
  updateQuotations,
  updateQuotationMany,
  getContactByRut,
  createMyCase,
  createQuotationsMe,
  updateQuotationsMe,
  getQuotationByIdMe,
  getSignedDocumentQuotation,
  createQuotations,
  getQuotationById,
  getContractByRut,
  getAllManagements,
  getUsers,
  makeCall,
  getOrigins,
};
export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(QuotationDetalle);